import { zergApi } from "@/service/zerg";
const prefix = "/rrhh/discounts";

class DiscounstService {

    async getDiscounts(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-discounts`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async insertDiscounts(params) {
        try {
            const data = await zergApi.post(`${prefix}/insert-discount`, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;

        } catch (error) {
            throw error;
        }
    }

    async editDiscounts(params) {
        try {
            const data = await zergApi.post(`${prefix}/edit-discount`, params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async approveDiscounts(params) {
        try {
            const data = await zergApi.post(`${prefix}/approve-discount`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDiscountTypes(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-discount-types`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEmployeeByArea(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-employee-by-area`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDiscountFractionsById(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-discount-fractions-by-id`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDiscountById(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-discount-by-id`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDiscount_tracking(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-discount-tracking`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async anulleDiscount(params) {
        try {
            const data = await zergApi.post(`${prefix}/anulle-discount`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getPendingDiscountsSum(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-pending-discounts-sum`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getActiveEmployees(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-active-employees`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDescuentosReporte(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-descuentos-reporte`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async deleteSustento(params) {
        try {
            const data = await zergApi.post(`${prefix}/delete-sustento`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcel(params) {
        try {
            const data = await zergApi.post(`${prefix}/excel`, params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcelReport(params) {
        try {
            const data = await zergApi.post(`${prefix}/excel-report`, params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDescuentosReporteDetalle(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-descuentos-reporte-detalle`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcelReporteDetalle(params) {
        try {
            const data = await zergApi.post(`${prefix}/excel-report-detalle`, params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DiscounstService();